import { cipo } from 'cipo';

cipo.controller('notifController',
function ($scope, $state) {

});
